import $ from 'jquery';
import JQueryView, { on } from '../../../../common/views/jqueryView';

export default class FormView extends JQueryView {
  constructor() {
    super('.simple_form');
  }

  @on({ event: 'click', selector: '.js-toggle-password-trigger' })
  onToggleShowPassword(e: JQuery.ClickEvent) {
    $(e.currentTarget).toggleClass('is-checked');

    if ($(e.currentTarget).hasClass('is-checked')) {
      $('#user_password').attr('type', 'text');
    } else {
      $('#user_password').attr('type', 'password');
    }
  }
}
